export default `/* Ids Sub Tabs Component */
/**
 * Base Styles/Mixins for Ids Sub Tabs Component and all subcomponents.
 */
:host {
  display: block;
}

.ids-sub-tabs {
  display: block;
  margin-block-end: 0;
  margin-block-start: 0;
  padding-inline-start: 0;
}
.ids-sub-tabs.ids-sub-tabs-wrapped {
  display: flex;
  flex-flow: column wrap;
  max-height: 90vh;
  max-width: 100vw;
  width: max-content;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdGFicyIsInNvdXJjZXMiOlsiaWRzLXN1Yi10YWJzLnNjc3MiLCJpZHMtc3ViLXRhYnMtYmFzZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FDQUE7QUFBQTtBQUFBO0FER0E7RUFDRTs7O0FBR0Y7RUNGRTtFQUNBO0VBQ0E7RUFDQTs7QURHQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBS0EiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBJZHMgU3ViIFRhYnMgQ29tcG9uZW50ICovXG5AdXNlICcuL2lkcy1zdWItdGFicy1iYXNlJyBhcyAqO1xuXG46aG9zdCB7XG4gIGRpc3BsYXk6IGJsb2NrO1xufVxuXG4uaWRzLXN1Yi10YWJzIHtcbiAgQGluY2x1ZGUgcmVzZXQtbWVudS1zdHlsZSgpO1xuXG5cbiAgJi5pZHMtc3ViLXRhYnMtd3JhcHBlZCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWZsb3c6IGNvbHVtbiB3cmFwO1xuICAgIG1heC1oZWlnaHQ6IDkwdmg7XG4gICAgbWF4LXdpZHRoOiAxMDB2dztcblxuICAgIC8vIE5PVEU6IFwid2lkdGg6IG1heC1jb250ZW50XCIgZG9lc24ndCB3b3JrIGluIFNhZmFyaSBhbmQgRmlyZWZveFxuICAgIC8vIFNvIGFkZGVkIFwiYWZ0ZXJzaG93XCIgbWVudSBldmVudCB0byBjb25maWd1cmUgd2l0aCBtYW51YWxseVxuICAgIC8vIEBzZWUgSWRzTWVudUdyb3VwLmNvbmZpZ3VyZU1lZ2FNZW51KClcbiAgICB3aWR0aDogbWF4LWNvbnRlbnQ7XG4gIH1cbn1cbiIsIi8qKlxuICogQmFzZSBTdHlsZXMvTWl4aW5zIGZvciBJZHMgU3ViIFRhYnMgQ29tcG9uZW50IGFuZCBhbGwgc3ViY29tcG9uZW50cy5cbiAqL1xuLy8gUmVzZXRzIHRoZSBVc2VyLUFnZW50IHN0eWxlc2hlZXQgcnVsZXMgZm9yIGA8dWw+YCBpbiBDaHJvbWVcbkBtaXhpbiByZXNldC1tZW51LXN0eWxlKCkge1xuICBkaXNwbGF5OiBibG9jaztcbiAgbWFyZ2luLWJsb2NrLWVuZDogMDtcbiAgbWFyZ2luLWJsb2NrLXN0YXJ0OiAwO1xuICBwYWRkaW5nLWlubGluZS1zdGFydDogMDtcbn1cbiJdfQ== */`;
